import { Box, Divider, Grid, Typography } from "@mui/material";
import { ReactNode, useEffect, useRef } from "react";
import PdfCompanyInfo from "./PdfCompanyInfo";
import LogisticPdfHighlight from "./LogisticPdfHighlight";
import LogisticPdfLeftInfo from "./LogisticPdfLeftInfo";
import LogisticPdfRightInfo from "./LogisticPdfRightInfo";
import { IPdfInfo } from "../../../types/global";
import LogisticPdfFooter from "./LogisticPdfFooter";
import LogisticPdfSigner from "./LogisticPdfSigner";

type Props = {
  name: string;
  highlightSection: IPdfInfo;
  leftSection: IPdfInfo;
  rightSection: IPdfInfo;
  data: any;
  summary: boolean;
  multiplePage: boolean;
  page: number;
  allPages: number;
  children: ReactNode;
};

const LogisticPdfLayout = ({
  name,
  highlightSection,
  leftSection,
  rightSection,
  data,
  summary,
  multiplePage,
  page,
  allPages,
  children,
}: Props) => {
  const headerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (headerRef.current) {
      const height = headerRef.current.offsetHeight;
      document.documentElement.style.setProperty(
        "--header-height",
        `${height}px`
      );
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          width: "210mm",
          height: "297mm",
          border: "1px solid #eee",
          borderRadius: "5px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: "28px",
          mb: 5,
        }}
      >
        <Box id="print-header" ref={headerRef} height="80mm">
          <Grid container spacing={1.5}>
            <Grid item xs={7}>
              <PdfCompanyInfo branch_unique_id={data.branch.unique_id} />
              <Divider sx={{ my: 1 }} />
              <LogisticPdfLeftInfo
                headers={leftSection.headers}
                info={leftSection.info}
              />
            </Grid>
            <Grid item xs={5}>
              <Typography
                fontSize={26.66}
                fontWeight={600}
                align="right"
                color={"primary.main"}
              >
                {name}
              </Typography>
              <LogisticPdfHighlight
                headers={highlightSection.headers}
                info={highlightSection.info}
              />
              <LogisticPdfRightInfo
                headers={rightSection.headers}
                info={rightSection.info}
              />
            </Grid>
          </Grid>
          <Box id="print-content">{children}</Box>
        </Box>
        <Box mt="auto">
          <LogisticPdfFooter data={data} />
          <Box mt="16px">
            <Divider sx={{ mb: 1 }} />
            <LogisticPdfSigner
              status={data.aggrid_status}
              created_by={data.created_by}
              issue_date={data.issue_date}
            />
            <Divider sx={{ mt: 1 }} />
          </Box>
        </Box>
        <Box
          sx={{
            fontSize: "10px",
            color: "#737373",
            position: "absolute",
            bottom: 10,
            right: 24,
          }}
        >
          หน้า {page}/{allPages}
        </Box>
      </Box>
    </>
  );
};

export default LogisticPdfLayout;
